import { render } from "./Sunkus.vue?vue&type=template&id=735b98f5"
import script from "./Sunkus.vue?vue&type=script&setup=true&lang=js"
export * from "./Sunkus.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/blogs/Sunkus.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "735b98f5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('735b98f5', __exports__)) {
    api.reload('735b98f5', __exports__)
  }
  
  module.hot.accept("./Sunkus.vue?vue&type=template&id=735b98f5", () => {
    api.rerender('735b98f5', render)
  })

}


export default __exports__